import React from 'react';
export function Footer() {
  return <footer className="bg-white border-t border-neutral-200 py-12 px-4 text-center mt-12" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <div className="font-display text-xl font-bold text-brand-title mb-4" data-id="element-127">
          🧴 EL AUDITOR DE SKINCARE™
        </div>

        <div className="font-body text-xs text-brand-text mb-4" data-id="element-128">
          © El Auditor de Skincare™ — Todos los derechos reservados
        </div>

        <div className="font-body text-xs text-brand-subtitle" data-id="element-129">
          Precios en euros (€). Pago procesado de forma segura.
        </div>
      </div>
    </footer>;
}